"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_weblab_tscommon_1 = require("@amzn/amazon-config-store-weblab-tscommon");
var AbstractOfflineClientSettings_1 = __importDefault(require("./AbstractOfflineClientSettings"));
var OfflineAsyncClientSettings = /** @class */ (function (_super) {
    __extends(OfflineAsyncClientSettings, _super);
    function OfflineAsyncClientSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OfflineAsyncClientSettings.prototype.createWeblabRulesResolver = function (options) {
        return new amazon_config_store_weblab_tscommon_1.WeblabRulesAsyncResolverImpl(options.weblabTreatmentResolver, options.weblabWithContextTreatmentResolver);
    };
    return OfflineAsyncClientSettings;
}(AbstractOfflineClientSettings_1.default));
exports.default = OfflineAsyncClientSettings;
